import { PlusIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { ChatHistory } from '@/components/chat/ChatHistory';
import { useChat } from '@/hooks/use-chat';

export function ChatSidebar() {
  const navigate = useNavigate();
  const { startNewChat } = useChat();
  
  const handleNewChat = () => {
    startNewChat();
    // Navigate to clean chat URL
    navigate('/chat');
  };
  
  return (
    <div className="flex flex-col h-full">
      {/* Header - removed label as requested */}
      <div className="flex items-center justify-between p-4 border-b border-indigo-500/10">
        {/* Removed 'Conversations' label */}
      </div>
      
      {/* Chat history list */}
      <div className="flex-1 overflow-auto">
        <ChatHistory />
      </div>
    </div>
  );
}
